
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectId]",
      function () {
        return require("private-next-pages/[projectId].tsx");
      }
    ]);
  